/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Hide_DetailsInputs */



/**
* | output |
* | --- |
* | "Hide Details" |
*
* @param {Error_Hide_DetailsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const error_hide_details = /** @type {((inputs?: Error_Hide_DetailsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Hide_DetailsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Details ausblenden")
	return /** @type {LocalizedString} */ ("Hide Details")
});